import Vue from 'vue'

import DrawerDoc from './drawer/Drawer-Doc.vue'
import DrawerList from './drawer/Drawer-List.vue'
import Drawer from './drawer/Drawer.vue'

import MenuBar from './part/MenuBar.vue'

import HeaderWelcome from './part/HeaderWelcome.vue'
import FooterWelcome from './part/FooterWelcome.vue'
import HeaderSimple from './part/HeaderSimple.vue'
import FooterSimple from './part/FooterSimple.vue'
import HeaderLab from './part/HeaderLab.vue'
import AccountMenu from './part/AccountMenu.vue'
import LogoImage from './part/LogoImage.vue'
import DocumentInfo from './part/DocumentInfo'

import FormManualInput from './form/ManualInput.vue'
import FormInputVuetify from './form/InputVuetify.vue'
import FormLogin from './form/Login.vue'
import FormRegister from './form/Register.vue'
import FormForgotUsername from './form/ForgotUsername.vue'
import FormForgotPassword from './form/ForgotPassword.vue'
import FormForgotEmail from './form/ForgotEmail.vue'
import FormPlans from './form/Plans.vue'
import FormPayment from './form/Payment.vue'
import FormPaymentAuto from './form/PaymentAuto.vue'
import FormPaypal from './form/Paypal.vue'

import EditorTiptap from './editor/Tiptap.vue'
import EditorTiptapBubble from './editor/Tiptap-bubble.vue'

import Tree from './tree/Tree.vue'
import ImproveDocInfo from './whole/ImproveDocInfo.vue'
import Comments from './whole/Comments.vue'

Vue.component('DrawerDoc', DrawerDoc)
Vue.component('DrawerList', DrawerList)
Vue.component('Drawer', Drawer)

Vue.component('MenuBar', MenuBar)

Vue.component('HeaderWelcome', HeaderWelcome)
Vue.component('FooterWelcome', FooterWelcome)
Vue.component('HeaderSimple', HeaderSimple)
Vue.component('FooterSimple', FooterSimple)
Vue.component('HeaderLab', HeaderLab)
Vue.component('AccountMenu', AccountMenu)
Vue.component('LogoImage', LogoImage)
Vue.component('DocumentInfo', DocumentInfo)

Vue.component('ManualInputForm', FormManualInput)
Vue.component('InputVuetifyForm', FormInputVuetify)
Vue.component('FormLogin', FormLogin)
Vue.component('FormRegister', FormRegister)
Vue.component('FormForgotUsername', FormForgotUsername)
Vue.component('FormForgotPassword', FormForgotPassword)
Vue.component('FormForgotEmail', FormForgotEmail)
Vue.component('FormPlans', FormPlans)
Vue.component('FormPayment', FormPayment)
Vue.component('FormPaymentAuto', FormPaymentAuto)
Vue.component('FormPaypal', FormPaypal)

Vue.component('EditorTiptap', EditorTiptap)
Vue.component('EditorTiptapBubble', EditorTiptapBubble)

Vue.component('AppTree', Tree)

Vue.component('ImproveDocInfo', ImproveDocInfo)

Vue.component('Comments', Comments)


// WEBPACK FOOTER //
// ./src/components/shared_components/index.js